
const TabButton = (props) => {
  const { active, onClick, children } = props;
  return (
    <button
      onClick={onClick}
      className={`px-3 py-2 font-medium text-xs rounded-lg transition-colors whitespace-nowrap flex-shrink-0 ${
        active ? "bg-blue-50 text-blue-600" : "text-gray-600 hover:text-blue-600"
      }`}
      style={{ minWidth: "max-content", padding: "0.5rem 0.75rem" }}
    >
      {children}
    </button>
  );
};

export const TabNavigation = (props) => {
  const { activeTab, onTabChange, availableTabs } = props;
  return (
  <div className="border-b border-gray-100">
    <div className="px-4 py-3 flex gap-2 overflow-x-auto scrollbar-hide">
      {availableTabs.map((tab) => (
        <TabButton
          key={tab.id}
          active={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </TabButton>
      ))}
    </div>
  </div>
  );
};
